import React, { useState, useEffect, useRef } from 'react';

import { useMasterContext } from '../contexts/MasterContext';

import BlogPosts from '../components/Home/BlogPosts';

import H2 from '../components/UI/H2';
import H3 from '../components/UI/H3';
import Button from '../components/UI/Button';

const Campaign = () => {

    const { showBlogPosts } = useMasterContext();

    return (
        <div class="animate-fade">
            {showBlogPosts && <BlogPosts />}
            <div class="space-y-12">
                <div class="max-w-7xl px-4 d:px-0 mx-auto space-y-12 font-serif pb-24">
                    <div class="max-w-5xl mx-auto flex flex-col items-center justify-center mt-12 space-y-12">
                        <H3 text="Campaign" />
                        <H2 text="Jami Announces Bid for New York's 12th Congressional District" />
                        <p className="text-gray-700 text-center text-lg">In 2026, Jami launched a campaign for Congress in New York&apos;s 12th District with a clear vision: a safer city where families and small businesses can truly thrive. The campaign focused on meeting residents where they are — in part by walking block by block through the heart of Manhattan, listening to neighbors, workers, and shop owners, and bringing their priorities towards the center of the race. Click below to see the map that marks Jami's journey and the conversations shaping the campaign.</p>                      
                        <Button href="https://my.atlist.com/map/474edd3f-919b-4d6e-bd76-7917bb98b40a?share=true" text="View the Campaign Map" color="gray" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Campaign;